import { Badge } from '@chakra-ui/react';
import { Trans } from '@lingui/react/macro';
import type { UnitPlacementStatus } from '@duke-hq/shared-constants/workPlacementStatus';

export function WorkPlacementStatusBadge({
  status,
}: {
  status?: UnitPlacementStatus;
}): React.ReactElement {
  return (
    <Badge
      colorScheme={status === 'COMPLETE' ? 'green' : status === 'IN_PROGRESS' ? 'blue' : 'gray'}
      variant="subtle"
      borderRadius="full"
      textTransform="none"
      fontWeight="medium"
      fontSize="xs"
      px={2}
      whiteSpace="nowrap"
    >
      {status === 'COMPLETE' ? (
        <Trans>Work placement complete</Trans>
      ) : status === 'IN_PROGRESS' ? (
        <Trans>Work placement in progress</Trans>
      ) : status === 'NOT_STARTED' ? (
        <Trans>Work placement not started</Trans>
      ) : (
        <Trans>Work placement required</Trans>
      )}
    </Badge>
  );
}
